const CustomIcons = [
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Circle-Red.svg', name: 'circle-red' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Circle-Green.svg', name: 'circle-green' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Circle-Blue.svg', name: 'circle-blue' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Circle-Yellow.svg', name: 'circle-yellow' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Square-Red.svg', name: 'square-red' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Square-Green.svg', name: 'square-green' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Square-Blue.svg', name: 'square-blue' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Square-Yellow.svg', name: 'square-yellow' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Triangle-Red.svg', name: 'triangle-red' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Triangle-Green.svg', name: 'triangle-green' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Triangle-Blue.svg', name: 'triangle-blue' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Triangle-Yellow.svg', name: 'triangle-yellow' },
  { src: window.SITE_BASE + '/assets/images/map-icons/Map-Icons_Circle.svg', name: 'circle' },
]

export default CustomIcons